import { AxiosRequestConfig } from 'axios';
import { api } from 'shared/api';

import { GeocoderResponse, PlaceAutocompletePrediction } from './types';

export async function fetchLocationsAutocomplete(input: string, sessionToken: string, signal?: AbortSignal) {
    const config: AxiosRequestConfig = {
        params: {
            input,
            sessionToken
        },
        signal
    };

    return api.get<PlaceAutocompletePrediction[]>(`locations/autocomplete`, undefined, config);
}

export async function fetchLocationDetails(placeId: string, signal?: AbortSignal) {
    const config: AxiosRequestConfig = {
        signal
    };

    return api.get<GeocoderResponse>(`locations/places/${ placeId }`, undefined, config);
}
